import React, { useState } from "react";
import { renovaLoginBack, renovaLogoMini } from "helper/constant";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import AuthActions from "redux/auth/actions";
import enhancer from "./enhancer/LoginFormEnhancer";
import CustomToast from 'components/notifications/CustomToast';

const { login } = AuthActions;

const Login = props => {

    const [topRight, setTopRight] = useState(false);
    const [loginErrors, setLoginErrors] = useState();


    const handleLogin = e => {
        e.preventDefault();
        setTopRight(false);
        setLoginErrors('');

        let { values, handleSubmit } = props;

        if (values.email !== "" && values.password !== "") {
            // console.log("Here is your form value", values);
            fetch("/login", {
                method: "POST",
                body: JSON.stringify(values)
            }).then((response) => {
                return response.json();
            }).then((data) => {
                if(data.login) {
                    props.login(data.user);
                    props.history.push("/dashboard");
                } else if(data.err) {
                    setTopRight(true)
                    setLoginErrors('Girilen kriterlere göre bir kullanıcı bulunamadı.')
                    
                }
            }).catch(e => {
            })
        }
        handleSubmit();
    };



    const { values, handleChange, handleBlur, errors, touched, submitCount } = props;
    //`url(${loginBack})`
    const loginContainer = {
        backgroundImage: `url(${renovaLoginBack})`,
        backgroundPosition: "center center",
        backgroundSize: "cover",
        position: "fixed",
        overflow: "auto",
        top: 0,
        bottom: 0,
    };

    

    const Error = props => {
        const field1 = props.field;
        if ((errors[field1] && touched[field1]) || submitCount > 0) {
            return (
                <span className={props.class ? props.class : "error-msg"}>
                    {errors[field1]}
                </span>
            );
        } else {
            return <span />;
        }
    };

    return (
        <div className="container-fluid" style={loginContainer}>
            <div className="form-container">
                <div className="login-icon">
                    <img src={renovaLogoMini} alt="icon" height="100px" />
                </div>
                <div className="login-title"><span style={{"color": "#ff0927", "fontWeight": "bold"}}>Renova Medikal Mühendislik</span> Magnet uygulamasına hoşgeldiniz.</div>
                <form className="pa-24" onSubmit={handleLogin}>
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            className="form-control react-form-input"
                            id="email"
                            onChange={handleChange}
                            value={values.email}
                            onBlur={handleBlur}
                            placeholder="info@renovamedikal.com.tr"
                        />
                        <Error field="email" />
                    </div>

                    <div className="form-group">
                        <label>Şifre</label>
                        <input
                            type="password"
                            className="form-control react-form-input"
                            id="password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="****"
                        />
                        <Error field="password" />
                    </div>

                    <button type="submit" className="btn form-button">
                        Giriş
                    </button>
                    
                </form>
            </div>

            <CustomToast
                heading={"Hata!"}
                width={400}
                show={topRight}
                transition
                position="top-right" 
                className="c-danger"
                message={loginErrors}
                onCloseCLick={() =>
                    setTopRight(false)
                }
            />
        </div>
    );
};

export default compose(
    withRouter,
    enhancer,
    connect(
        null,
        { login }
    )
)(Login);
